import { handleError, hasError, tryCatch } from '@repo/shared/api/helpers'
import { CaseWorkersRoutes2 } from '@repo/shared/routes-case-workers'
import { AxiosInstance } from 'axios'

import { ICaseWorkersApi } from '@/spi/api/case-workers'

export const buildCaseWorkersApi = (axios: AxiosInstance): ICaseWorkersApi => ({
  assignCaseWorkerToBeneficiary: async ({ organizationId, caseWorkerId, beneficiaryId }) => {
    const response = await tryCatch(async () =>
      axios.patch<typeof CaseWorkersRoutes2.assignCaseWorkerToBeneficiary.response>(
        CaseWorkersRoutes2.assignCaseWorkerToBeneficiary.getPath({
          organizationId,
          caseWorkerId,
          beneficiaryId,
        }),
      ),
    )

    if (hasError(response)) return handleError(response)
    return { success: true }
  },

  unassignCaseWorkerFromBeneficiary: async ({ organizationId, caseWorkerId, beneficiaryId }) => {
    const response = await tryCatch(async () =>
      axios.patch<typeof CaseWorkersRoutes2.unassignCaseWorkerFromBeneficiary.response>(
        CaseWorkersRoutes2.unassignCaseWorkerFromBeneficiary.getPath({
          organizationId,
          caseWorkerId,
          beneficiaryId,
        }),
      ),
    )

    if (hasError(response)) return handleError(response)
    return { success: true }
  },

  assignCaseWorkerToBeneficiariesFromFilters: async ({
    organizationId,
    caseWorkerId,
    filters,
    sortOption,
  }) => {
    const response = await tryCatch(async () =>
      axios.patch<typeof CaseWorkersRoutes2.assignCaseWorkerToBeneficiariesFromFilters.response>(
        CaseWorkersRoutes2.assignCaseWorkerToBeneficiariesFromFilters.getPath({
          organizationId,
          caseWorkerId,
        }),
        {
          payload: {
            filters,
            sortOption,
          },
        } satisfies typeof CaseWorkersRoutes2.assignCaseWorkerToBeneficiariesFromFilters.request,
      ),
    )

    if (hasError(response)) return handleError(response)
    return { success: true }
  },

  unassignCaseWorkerFromBeneficiariesFromFilters: async ({
    organizationId,
    caseWorkerId,
    filters,
    sortOption,
  }) => {
    const response = await tryCatch(async () =>
      axios.patch<
        typeof CaseWorkersRoutes2.unassignCaseWorkerFromBeneficiariesFromFilters.response
      >(
        CaseWorkersRoutes2.unassignCaseWorkerFromBeneficiariesFromFilters.getPath({
          organizationId,
          caseWorkerId,
        }),
        {
          payload: {
            filters,
            sortOption,
          },
        } satisfies typeof CaseWorkersRoutes2.unassignCaseWorkerFromBeneficiariesFromFilters.request,
      ),
    )

    if (hasError(response)) return handleError(response)
    return { success: true }
  },
})
